module.exports = __webpack_public_path__ + "media/images/icons/icon_loader-cbee938a01b81804d0e29d5a1d407ce5.png";